import { useState } from "react";
import Link from "next/link";
import { siteSettings } from "@/settings/site-settings";
import Scrollbar from "@/components/ui/scrollbar";
import ChevronDown from "../ui/icons/chevron-down";
import { useUI } from "@/contexts/ui.context";
import Instagram from "../ui/icons/instagram";
import Facebook from "../ui/icons/facebook";
import Email from "../ui/icons/email";
import Linkedin from "../ui/icons/linkedin";
import Whatsapp from "../ui/icons/whatsapp";
import Location from "../ui/icons/location";
import { AnimatePresence, m } from "framer-motion";
const iconClass =
  "hover:text-darkBeige text-darkGrey transition-all duration-300 ease p-1";
const socials = [
  {
    link: "mailto:sales@chalkstudio.design?subject=Hello",
    icon: <Email className={iconClass} />,
  },
  {
    link: "https://www.linkedin.com/company/chalkstudio-design/?originalSubdomain=in",
    icon: <Linkedin className={iconClass} />,
  },
  {
    link: "https://instagram.com/chalkstudio.design?igshid=pvatrq7m4wxm",
    icon: <Instagram className={iconClass} />,
  },
  {
    link: "https://www.facebook.com/chalkstudiodesign/",
    icon: <Facebook className={iconClass} />,
  },
  {
    link: "https://wa.link/jnn17z",
    icon: <Whatsapp className={iconClass} />,
  },
  {
    link: "https://maps.app.goo.gl/oCJkH7WPuVefRzbNA",
    icon: <Location className={iconClass} />,
  },
];

export default function MobileMenu() {
  const { site_header } = siteSettings;
  const { setIsMenuOpen } = useUI();

  return (
    <>
      <div className="flex flex-col justify-between w-full h-full bg-beige">
        <Scrollbar className="flex-grow mb-auto menu-scrollbar">
          <div className="flex flex-col w-full items-start justify-start py-0 lg:px-2 text-heading px-4 md:px-8">
            {site_header.menu.map((menu, index) =>
              menu?.subMenu ? (
                <Accordion
                  title={menu?.label}
                  initial={index == 1 ? true : false}
                  key={"menu" + index}
                >
                  <div className="w-full flex flex-col items-start justify-start mb-4">
                    {menu?.subMenu?.map((row, index) => {
                      return (
                        <Link
                          href={row?.path}
                          key={"caategory" + index}
                          onClick={() => setIsMenuOpen(false)}
                          className="group flex justify-start items-center group/card text-center flex-col"
                        >
                          <p
                            variant="subTitle"
                            className="w-full text-darkGrey text-base menu-item relative py-2 pl-4 transition duration-300 ease-in-out"
                          >
                            - {row?.label}
                          </p>
                        </Link>
                      );
                    })}
                  </div>
                </Accordion>
              ) : (
                <div
                  key={"link" + index}
                  className="w-full text-darkGrey text-base menu-item relative py-4 mb-0.5 border-b border-darkGrey/20 last:border-b-0 transition duration-300 ease-in-out"
                >
                  <Link
                    href={menu?.path}
                    onClick={() => setIsMenuOpen(false)}
                    className="text-inherit"
                  >
                    {menu?.label}
                  </Link>
                </div>
              )
            )}
          </div>
          <Link
            href="/contact-us"
            onClick={() => setIsMenuOpen(false)}
            className="capitalize rounded-full bg-darkGrey shrink-0 mb-4 lg:text-base text-sm md:max-w-[155px] md:max-h-[55px] w-[200px] mx-auto h-[40px] flex items-center justify-center hover:bg-white hover:text-darkGrey transition-all duration-300 ease text-center text-white font-body"
          >
            get in touch
          </Link>
        </Scrollbar>

        <div className="flex items-center justify-center flex-shrink-0 pt-4 bg-inherit border-t border-darkGrey/20 px-7 gap-x-1">
          <div className="flex flex-row gap-0">
            {socials?.map((row, key) => (
              <a
                href={row.link}
                target="_blank"
                rel="noreferrer"
                key={"social" + key}
                className="w-12 h-12"
              >
                {row?.icon}
              </a>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
const Accordion = ({ children, initial = false, title }) => {
  const [open, setOpen] = useState(initial ?? false);
  return (
    <div
      className={`px-0 w-full mb-0.5 border-b border-darkGrey/20 last:border-b-0 group flex flex-col z-0 last:border-b-0 overflow-hidden cursor-pointer`}
    >
      <div
        className="flex flex-row justify-between items-center py-4 h-auto w-full relative"
        onClick={() => setOpen(!open)}
      >
        <p
          className={`w-full text-darkGrey text-base menu-item relative transition duration-300 ease-in-out`}
        >
          {title}
        </p>
        {/* <div
          className={`w-3 h-3 transition-all text-body duration-400 ease transform mr-2 ${
            !open ? "rotate-0" : "-rotate-180"
          } relative`}
        > */}
        <ChevronDown
          className={`text-xl transition duration-300 ease transform text-heading arrow flex justify-end items-center ${
            open ? "-rotate-180" : "rotate-0"
          }`}
        />
        {/* </div> */}
      </div>
      <AnimatePresence initial={false}>
        {open && (
          <m.section
            key="content"
            initial="collapsed"
            animate="open"
            exit="collapsed"
            variants={{
              open: { height: "auto", opacity: 1 },
              collapsed: { height: "0px", opacity: 0 },
            }}
            transition={{ duration: 0.6, ease: [0.04, 0.62, 0.23, 0.98] }}
          >
            <m.div
              variants={{ collapsed: { opacity: 0.8 }, open: { opacity: 1 } }}
              transition={{ duration: 0.3 }}
              className="w-full"
            >
              {children}
            </m.div>
          </m.section>
        )}
      </AnimatePresence>
    </div>
  );
};
